import React from 'react';

function DogHandlerSecurityDetails() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold mb-8 text-center">Dog Handler Security UK</h1>
      <div className="bg-gray-900 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200">
        <h2 className="text-3xl font-semibold mb-4 text-white">Overview</h2>
        <p className="text-white mb-4">
          Our dog handler security services in the UK provide a high level of security for various sites, including events, construction sites, and private properties. Our trained dog handlers and their dogs are skilled in detecting and deterring potential threats.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-white">Services We Offer</h2>
        <ul className="list-disc list-inside text-white space-y-2">
          <li>Event Security</li>
          <li>Construction Site Security</li>
          <li>Residential Security</li>
          <li>Industrial Site Security</li>
          <li>Patrol and Response Services</li>
          <li>Threat Detection and Deterrence</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Why Choose Us?</h2>
        <p className="text-white mb-4">
          Our team of experienced dog handlers in the UK is committed to providing top-notch security services. We utilize well-trained dogs and the latest techniques to ensure the safety and security of your property.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Contact Us</h2>
        <p className="text-white">
          For more information about our dog handler security services in the UK, please contact us at <a href="tel:07460395006" className="text-yellow-500 hover:underline">0746 039 5006</a> or email us at <a href="mailto:info@crowndefencesecurity.co.uk" className="text-yellow-500 hover:underline">info@crowndefencesecurity.co.uk</a>.
        </p>
      </div>
    </div>
  );
}

export default DogHandlerSecurityDetails;
